import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-locationdeliverycharge',
  templateUrl: './locationdeliverycharge.page.html',
  styleUrls: ['./locationdeliverycharge.page.scss'],
})
export class LocationdeliverychargePage implements OnInit {
  location: string = '';
  meta: any = [];
  @Input() code: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  dataForm: FormGroup;
  constructor(public modalController: ModalController, public alertController: AlertController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'from_km': new FormControl(null, [Validators.required]),
      'to_km': new FormControl(null, [Validators.required]),
      'amount': new FormControl(null, [Validators.required]),
      'margin_percentage': new FormControl(null, [Validators.required]),
      'status': new FormControl(true, [Validators.required]),
    });
    if (this.code != '') {
      this.getDetail();
    }
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  add() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'status') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.post('location_deliverycharge/' + this.code, formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.getDetail();
        this.dataForm.reset();
        this.dataForm.controls['status'].setValue(true);
      } else {
        this.commonFunctions.presentAlertConfirm('Information', data['message']);
      }
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  async removeLocation(code) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: "Are you sure?",
      message: "Do you really want to remove this location?",
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Confirm No');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.isProcessing = true;
            this.restApi.del('location_deliverycharge/' + code).subscribe((data: any) => {
              this.isProcessing = false;
              if (data['code'] == 200) {
                this.getDetail();
              } else {
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }
            });
          }
        }
      ]
    });
    await alert.present();
  }

  getDetail() {
    this.isProcessing = true;
    this.restApi.get('location_deliverycharge/' + this.code).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.meta = data.data;
        this.location = data.location;
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }
}
